(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fadedwave-hero"] && !Shopify.designMode) return;
  try {
    

  (function () {
    const sectionId = '{{ section.id }}';

    // ── VU meter ──
    const vuWrap = document.getElementById('fw-vu-' + sectionId);
    if (vuWrap) {
      const barCount = 20;
      const bars     = [];
      for (let i = 0; i < barCount; i++) {
        const b = document.createElement('div');
        b.className    = 'fw-vu-bar';
        b.style.height = '4px';
        vuWrap.appendChild(b);
        bars.push(b);
      }
      function animateVU() {
        const level = 0.4 + Math.random() * 0.45;
        bars.forEach(function (b, i) {
          const active = (i / barCount) < level;
          const h      = active ? 4 + (26 - 4) * (i / barCount) * 1.15 : 4;
          b.style.height    = Math.min(h, 26) + 'px';
          b.style.background  = active ? (i > 15 ? '#7a1a08' : '#ff7a14') : '#1e1608';
          b.style.boxShadow   = (active && i <= 15) ? '0 0 5px rgba(255,120,20,0.4)' : 'none';
        });
        setTimeout(animateVU, 110 + Math.random() * 90);
      }
      animateVU();
    }

    // ── Draggable knobs ──
    document.querySelectorAll('#fw-hero-' + sectionId + ' .fw-knob-outer').forEach(function (knob) {
      let angle    = parseFloat(knob.dataset.angle) || 0;
      let dragging = false;
      let lastY    = 0;

      function setAngle(a) {
        angle = Math.max(-140, Math.min(140, a));
        knob.querySelector('.fw-knob-inner').style.transform = 'rotate(' + angle + 'deg)';
      }
      setAngle(angle);

      knob.addEventListener('mousedown', function (e) {
        dragging = true; lastY = e.clientY;
        document.body.style.cursor = 'grabbing';
        e.preventDefault();
      });
      knob.addEventListener('touchstart', function (e) {
        dragging = true; lastY = e.touches[0].clientY;
        e.preventDefault();
      }, { passive: false });

      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        const d = lastY - e.clientY; lastY = e.clientY;
        setAngle(angle + d * 2.2);
      });
      window.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        const d = lastY - e.touches[0].clientY; lastY = e.touches[0].clientY;
        setAngle(angle + d * 2.2);
        e.preventDefault();
      }, { passive: false });

      window.addEventListener('mouseup',  function () { dragging = false; document.body.style.cursor = ''; });
      window.addEventListener('touchend', function () { dragging = false; });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
